import styled from 'styled-components';
import { allProps, Box, Colors, CustomTheme } from '@altermaind/web/ui';
import { convertColorToRgba } from '@/_shared/helpers';

type TooltipBoxProps = {
  backgroundColor: keyof Colors;
  tooltipPosition: 'top' | 'bottom' | 'left' | 'right';
};

// Box that displays the tooltip text
export const TooltipBox = styled(Box)<TooltipBoxProps>(
  ({ theme, tooltipPosition, backgroundColor: tooltipBackgroundColor }) => {
    const backgroundColor = convertColorToRgba(
      (theme.colors as keyof CustomTheme['colors'])[tooltipBackgroundColor],
      1,
    );

    return `
		background-color: ${backgroundColor}
    z-index: 1000;
    opacity: 1;
    visibility: visible;
    transition: opacity 0.2s ease-in-out;

    /* These properties (left, transform, etc.) may be overwritten inline in the portal's style (style={{ ... }}) */
    
    ${
      (tooltipPosition === 'top' || tooltipPosition === 'bottom') &&
      `
          left: 50%;
          transform: translateX(-50%);
          height: fit-content;
          &::after {
            content: "";
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            border-width: 8px;
            border-style: solid;
          }
        `
    }
		${
      (tooltipPosition === 'left' || tooltipPosition === 'right') &&
      `
          top: 50%;
          transform: translateY(-50%);
          height: fit-content;
          &::after {
            content: "";
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            border-width: 8px;
            border-style: solid;
          }
        `
    }

    ${
      tooltipPosition === 'top' &&
      `
            bottom: 100%;
            margin-bottom: 8px;
            &::after {
              top: 100%;
              /* For a tooltip on top, the arrow points down */
              border-color: ${backgroundColor} transparent transparent transparent;
            }
          `
    }
		${
      tooltipPosition === 'bottom' &&
      `
            top: 100%;
            margin-top: 8px;
            &::after {
              bottom: 100%;
              /* For a tooltip at the bottom, the arrow points up */
              border-color: transparent transparent ${backgroundColor} transparent;
            }
          `
    }
		 ${
       tooltipPosition === 'left' &&
       `
            right: 100%;
            margin-right: 8px;
            &::after {
              left: 100%;
              /* For a tooltip on the left, the arrow points right */
              border-color: transparent transparent transparent ${backgroundColor};
            }
          `
     }
			${
        tooltipPosition === 'right' &&
        `
            left: 100%;
            margin-left: 8px;
            &::after {
              right: 100%;
              /* For a tooltip on the right, the arrow points left */
              border-color: transparent ${backgroundColor} transparent transparent;
            }
          `
      }
  `;
  },
  allProps,
);
